import { Platform } from 'react-native';
import { readWebStorage, removeWebStorage, writeWebStorage } from './web-storage';
import { createSecureStoreKey } from './secure-store-key';

export interface StoredPublicShortlistSession {
  id: string;
  slug: string;
  reviewerName: string;
  sessionToken: string;
}

function webStorageKey(slug: string) {
  return `tabbio-public-shortlist-session:${slug}`;
}

function nativeStorageKey(slug: string) {
  return createSecureStoreKey('tabbio-public-shortlist-session', slug);
}

function readRaw(slug: string) {
  if (Platform.OS === 'web') {
    return readWebStorage(webStorageKey(slug));
  }

  try {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const SecureStore = require('expo-secure-store');
    return SecureStore.getItem(nativeStorageKey(slug));
  } catch {
    return null;
  }
}

function writeRaw(slug: string, value: string) {
  if (Platform.OS === 'web') {
    writeWebStorage(webStorageKey(slug), value);
    return;
  }

  try {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const SecureStore = require('expo-secure-store');
    SecureStore.setItem(nativeStorageKey(slug), value);
  } catch {
    // noop
  }
}

function deleteRaw(slug: string) {
  if (Platform.OS === 'web') {
    removeWebStorage(webStorageKey(slug));
    return;
  }

  try {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const SecureStore = require('expo-secure-store');
    void SecureStore.deleteItemAsync(nativeStorageKey(slug));
  } catch {
    // noop
  }
}

export async function readPublicShortlistSession(
  slug: string,
): Promise<StoredPublicShortlistSession | null> {
  const raw = readRaw(slug);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as StoredPublicShortlistSession;
    if (!parsed?.id || !parsed?.sessionToken) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export async function writePublicShortlistSession(
  slug: string,
  session: StoredPublicShortlistSession,
) {
  writeRaw(slug, JSON.stringify(session));
}

export async function clearPublicShortlistSession(slug: string) {
  deleteRaw(slug);
}
